/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/**
 * 事项商城表单，暂不支持插件
 *
 */
/* eslint-disable import/first */
import React, { useState, useEffect, useRef } from "react";
import { isNil, findIndex, map, max } from "lodash";
import update from "react-addons-update";
import { Message } from "@alifd/next";
import DeviceSdk from "@alife/devicetasksdk";
import { formRenderUsingGet } from "./service/accept/batchForm";
import Form from "./components/Form";
import SimpleFrom from "./form";
import GlobalMessage from "./components/GlobalMessage";
import ErrorTab from "./components/ErrorTab";
import MatterNav from "./components/MatterNav";
import "./index.scss";

UnionDetailForm.defaultProps = {
  matters: [],
};

function UnionDetailForm(props) {
  const { matters, params } = props;

  const formInstance = useRef(null);
  const [schemas, setSchemas] = useState({});
  const schemasData = useRef({});
  const matterIds = matters.map((item) => item.matterId);

  const fetchData = async (matterId) => {
    const res = await formRenderUsingGet({ ...params, matterId, detail: 1 });
    const { formSchema } = res?.data || {};
    const matterSchema = formSchema && JSON.parse(formSchema);
    schemasData.current = update(schemasData.current, {
      [matterId]: { $set: matterSchema },
    });
    setSchemas(schemasData.current);
  };

  const fetchAllData = async () => {
    const result = {};
    for (const matterId of matterIds) {
      result[matterId] = await fetchData(matterId);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, [matters]);

  const onFormReady = (instance) => {
    formInstance.current = instance;
  };

  return (
    <div className="gov-form-detail">
      {map(matters, (item) => {
        const { matterId, matterName } = item;
        const schema = schemas[matterId];
        return (
          <div className="union-form__group">
            <div className="union-form__title">{matterName}</div>
            {schema && (
              <SimpleFrom
                {...props}
                params={{ ...params, matterId }}
                code={matterId}
                detail
                schema={schema}
                initErrorMsg={false}
                onFormReady={onFormReady}
              />
            )}
            <div className="union-form__footer" />
          </div>
        );
      })}
    </div>
  );
}

UnionForm.defaultProps = {
  matters: [],
  submitUrl: "/api/reception/batchRecept/submit",
  draftUrl: "/api/reception/batchRecept/execute",
};

function UnionForm(props) {
  const {
    matters,
    params,
    initErrorMsg,
    onLoad,
    submitHandler,
    draftUrl,
    materialListPopup,
    formSavedMatter = [],
  } = props;

  const matterIds = matters.map((item) => item?.matterId);
  const initialFurthest =
    max(map(formSavedMatter, (matter) => matterIds.indexOf(matter))) || 0;
  const [current, setCurrent] = useState(matterIds[0]);
  const [furthest, setFurthest] = useState(initialFurthest); // 已经到达过的最远的事项 Index
  const [schema, setSchema] = useState();
  const [errorListVisible, setErrorListVisible] = useState(false);
  const [errorList, setErrorList] = useState([]);
  const [deviceVisible, setDeviceVisible] = useState(false);
  const [deviceStatus, setDeviceStatus] = useState("");
  const formInstance = useRef(null);

  const globalMessage = "";
  const disableDevicePlugin = false;
  const isEdit = false;

  const sdkStyleMap = {
    gpy: { width: "1000px", height: "636px" },
  };
  const sdkProps = {
    ...sdkStyleMap[deviceStatus],
    gpyTotal: "9",
    status: deviceStatus,
    visible: deviceVisible,
    closeDialog: () => {
      setDeviceVisible(false);
    },
    fail: () => {
      Message.warning("设备连接失败");
    },
    success: (data) => {
      // 调用sdk记录设备调用返回结果
      formInstance.current.formContext.emitter.emit(
        "callDeviceSdkSuccess",
        data
      );
    },
  };

  const fetchData = async () => {
    const res = await formRenderUsingGet({ ...params, matterId: current });
    const { formSchema } = res?.data || {};
    if (formSchema) {
      setSchema(JSON.parse(formSchema));
    }
  };

  useEffect(() => {
    fetchData();
  }, [current]);

  const save = async (event) => {
    return new Promise((resolve, reject) => {
      if (!formInstance.current) {
        submitHandler({ success: false, errorMsg: "表单仍在加载中", event });
        reject();
      }
      let options = {};
      if (event === "submit") {
        options = { actionCode: "BatchFormSubmit", matterId: current };
      }
      if (event === "saveDraft") {
        options = {
          actionCode: "BatchSaveFormDraft",
          url: draftUrl,
          draft: true,
          noValid: true,
          matterId: current,
        };
      }
      const currentIndex = findIndex(matterIds, (item) => item === current);
      const isLast = currentIndex === matterIds.length - 1;
      formInstance.current.submitManager
        .save(options)
        .then((res) => {
          submitHandler({ ...res, event, isLast });
          if (currentIndex > furthest) {
            setFurthest(currentIndex);
          }
          if (res.success) {
            resolve();
          } else {
            reject();
          }
        })
        .catch((res) => {
          reject();
          if (res.stack) {
            submitHandler({ success: false, errorMsg: res, event });
          } else {
            submitHandler({ ...res, success: false, event });
          }
        });
    });
  };

  const prev = () => {
    const currentIndex = findIndex(matterIds, (item) => item === current);
    const prevMatter =
      currentIndex > 0 ? matterIds[currentIndex - 1] : undefined;
    // 如果可以，跳转到上一个事项
    prevMatter && setCurrent(prevMatter);
  };

  const next = async () => {
    // 先保存，如果可以，跳转到下一个事项
    const currentIndex = findIndex(matterIds, (item) => item === current);
    const nextMatter =
      currentIndex < matterIds.length - 1
        ? matterIds[currentIndex + 1]
        : undefined;

    // 需要对当前页面进行提交操作,如果保存不成功，则无法跳转到下一个事项
    await save("submit");
    // 如果可以，跳转到上一个事项
    nextMatter && setCurrent(nextMatter);
  };

  const getErrorMsg = (options) => {
    return (
      formInstance.current && formInstance.current.fieldApi.getErrorMsg(options)
    );
  };

  const handleErrorListChange = ({ visible, errorList: errors } = {}) => {
    !isNil(visible) && setErrorListVisible(visible);
    !isNil(errors) && setErrorList(errors);
  };

  const handleCallDeviceSdk = ({ visible, status } = {}) => {
    !isNil(visible) && setDeviceVisible(visible);
    !isNil(status) && setDeviceStatus(status);
  };

  const triggerScrollField = (key) => {
    if (formInstance.current) {
      formInstance.current.fieldApi.scrollToField(key);
    }
  };

  useEffect(() => {
    const instance = {
      state: { pages: [] },
      prev,
      next,
      save,
      getErrorMsg,
      currentMatter: current,
    };
    onLoad(instance);
  }, [current, matters]);

  const onFormReady = (instance) => {
    formInstance.current = instance;
    formInstance.current.formContext.emitter.removeListener(
      "errorListChange",
      handleErrorListChange
    );
    formInstance.current.formContext.emitter.removeListener(
      "callDeviceSdk",
      handleCallDeviceSdk
    );
    formInstance.current.formContext.emitter.on(
      "errorListChange",
      handleErrorListChange
    );
    formInstance.current.formContext.emitter.on(
      "callDeviceSdk",
      handleCallDeviceSdk
    );
  };

  // 需要跳转的matterId，点击下一步，或者点击事项Nav可以触发 MatterChange
  // 当向前切换时，如果
  // 需要记录已保存过的最远步骤
  const handleMatterChange = async (matterId) => {
    // 校验matterId是否合法，只能跳转到之前的页面，或者下一步的页面
    const currentIndex = findIndex(matterIds, (item) => item === current);
    const matterIndex = findIndex(matterIds, (item) => item === matterId);
    const gap = matterIndex - currentIndex;
    if (gap > 1 && matterIndex > furthest) {
      return;
    }
    // 如果是下一步，则先调用提交
    // 如果时向前跳转，则调用保存草稿
    if (gap > 0) {
      await save("submit");
    } else {
      await save("saveDraft");
    }
    setCurrent(matterId);
  };

  return (
    <>
      {matters && (
        <MatterNav
          showMaterialList={materialListPopup}
          sequenceNo={params?.sequenceNo}
          currentMatter={current}
          dataSource={matters}
          onChange={handleMatterChange}
        />
      )}
      {globalMessage && <GlobalMessage message={globalMessage} />}
      <ErrorTab
        visible={errorListVisible}
        errorList={errorList}
        triggerScroll={triggerScrollField}
      />
      {schema && (
        <Form
          {...props}
          params={{ ...params, matterId: current }}
          isEdit={isEdit}
          disableDevicePlugin={disableDevicePlugin}
          schema={schema}
          initErrorMsg={initErrorMsg}
          onFormReady={onFormReady}
        />
      )}
      <DeviceSdk originProps={sdkProps} only="true" />
    </>
  );
}

export { UnionForm, UnionDetailForm };
